export default __webpack_public_path__ + "static/media/Autolysis_FR.ad2e6881.pdf";